var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembershipCrownDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.927 16.84H3.839c-.56 0-1.05-.382-1.185-.925L.037 5.444a1.222 1.222 0 011.731-1.39l4.223 2.112L9.335.593a1.222 1.222 0 012.096 0l3.344 5.574 4.223-2.112a1.222 1.222 0 011.732 1.39l-2.618 10.47a1.222 1.222 0 01-1.185.925z",
    fill: "#AFC4FF"
  })));
}

export default SvgMembershipCrownDisabled;